module.exports = __webpack_public_path__ + "img/y- (17).48941102.png";